import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root'
})
export class MessagesService {
  async #showToast(icon: 'error' | 'success' | 'warning', message: string): Promise<void> {
    const Swal = (await import('sweetalert2')).default

    const toast = Swal.mixin({
      toast: true,
      position: 'bottom',
      showConfirmButton: true,
      confirmButtonText: 'Cerrar',
      buttonsStyling: false,
      customClass: {
        popup: 'shadow-card',
        title: 'preset-body-3 md:preset-body-2',
        confirmButton: 'preset-title-6 md:preset-title-3 shadow-button-inset grow cursor-pointer rounded-3xl px-3 py-1 text-white bg-primary-500'
      }
    })

    await toast.fire({ icon, title: message })
  }

  error(message: string) {
    void this.#showToast('error', message)
  }

  success(message: string) {
    void this.#showToast('success', message)
  }

  warning(message: string) {
    void this.#showToast('warning', message)
  }

  async errorMessage(message: string) {
    const Swal = (await import('sweetalert2')).default
    Swal.fire({ icon: 'error', title: 'Error', text: message, confirmButtonText: 'Cerrar' })
  }
}
